import { useGemaCollection } from "./GemaContext";
import { lazy, Suspense } from "react";
import { RamonVideo } from "./RamonVideo";
import { FALLBACK_BY_STAGE, RAMON_RENDERER, type RamonProps } from "./types";
import "./ramon.css";

const RamonRive = lazy(() => import("./RamonRive").then(module => ({ default: module.RamonRive })));

/** Stable product API: changing video to Rive never reaches onboarding screens. */
export function Ramon(props: RamonProps) {
  const { collection } = useGemaCollection();
  const effective = { ...props, item: props.item === undefined ? collection?.equipped : props.item };
  const { stage, action, className = "", label = "Gema" } = props;
  return (
    <div className={`ramon ${className}`.trim()} role="img" aria-label={label} data-stage={stage} data-action={action} data-renderer={RAMON_RENDERER}>
      {RAMON_RENDERER === "rive" ? (
        <Suspense fallback={<img className="ramon-placeholder" src={FALLBACK_BY_STAGE[stage]} alt="" aria-hidden="true" />}>
          <RamonRive {...props} />
        </Suspense>
      ) : <RamonVideo {...effective} />}
    </div>
  );
}
